import React,{useState} from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import styled from 'styled-components';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const DatePicker = ({ name, minDOBirth,maxDOBirth,value, callBackFun}) => {

  const [val, setVal] = useState(value);
  return (
    <DatePickerWrapper>
              <div className='custom-date-piker'>
                <div
                  className='file-input-wrapper'
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      minDate={minDOBirth}
                      maxDate={maxDOBirth}                     
                      name={name}
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      value={val}
                      onChange={(date) => {
                        setVal(date)
                        return callBackFun(date);                          
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />

                  </MuiPickersUtilsProvider>

                </div>
              </div>

    </DatePickerWrapper>
  );
};

export default DatePicker;
const DatePickerWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin: 0;
  }
`
